import React, { useState, useRef, useEffect } from "react";
import "./home.css";
import DomoticNavbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import RedesNetworking from "./RyN.jsx";
import SpecializedSoftware from "./licenciamiento-software.jsx";
import { scrollToHash } from "./scrollToHash";

// Imágenes servicios domotica
import computoyconferencia from "./img-domotic/computoyvideoconfierencia.png";
import computoyconferencia2 from "./img-domotic/computoyvideoconferencia2.png";
import electrosec_cctv from "./img-domotic/electrosec_cctv1.png";
import licenciamiento_soft from "./img-domotic/licenciamiento_de_software.png"; 
import licenciamiento_soft2 from "./img-domotic/licenciamiento_de_software2.png";
import licenciamiento_soft3 from "./img-domotic/licenciamiento_de_software3.png";
import networking_redes from "./img-domotic/networkingyredes.png";
import networking_redes2 from "./img-domotic/networkingyredes2.png"; 
import pantallas_edu_señ from "./img-domotic/pantallaseducativas_señalizaciondigital.png";
import pantallas_edu_señ2 from "./img-domotic/pantallaseducativas_señalizaciondigital2.png";
import parqueaderos_inteligentes from "./img-domotic/parqueaderos_inteligentes.png";
import parqueaderos_inteligentes2 from "./img-domotic/parqueaderos_inteligentes2.png";
import puertas_de_seguridad from "./img-domotic/puertas_seguridad.png";
import sistemas_energia_solar from "./img-domotic/solarsystem1.png";
import sistemas_energia_solar2 from "./img-domotic/solarsystem2.png";
import sistemas_pos from "./img-domotic/sistemasPOS.png";
import IntelligentParking from "./parqueaderosInteligentes.jsx";

// Imágenes del carrusel
import img1 from "./img/ctrl_clim.png";
import img2 from "./img/ctrl_voz.png";
import img3 from "./img/ctrl_voz2.png";
import img4 from "./img/ctrl_persi.png";
import img5 from "./img/ctril_iluminacion.png";
import img6 from "./img/ctrl_clim.png";
import img7 from "./img/ctrl_clim.png";

import ContactForm from "./Contacto.jsx";
import BrandSlider from "../Components/Secc_marcas.jsx";




const Home = () => {
  const images = [img1, img2, img3, img4, img5, img6, img7];
  const carouselRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const itemsPerView = 5;
  






  return (
    <div className="domotic-home">
      <DomoticNavbar />

      <div className="services-alt-wrapper" style={{ marginTop: '8%', position: 'relative', zIndex: 10 }}>
  <section id="alt-servicios" className="alt-section">
    <div className="section-header">
      <h2 className="section-title">NUESTRAS SOLUCIONES TECNOLÓGICAS</h2>
      <div className="section-divider"></div>
    </div>

    {/* Solución 1 */}
    <a href="/RedesNetworking" className="service-row">
      <div className="service-item">
        <div className="service-image-container">
          <img src={networking_redes} alt="Networking y Redes" className="service-image" />
          <div className="image-overlay"></div>
        </div>
        <div className="service-content">
          <h3 className="service-title">NETWORKING Y REDES</h3>
          <p className="service-description">
            Infraestructura de red robusta y escalable para entornos empresariales con 
            tecnología de última generación y soporte especializado.
          </p>
        </div>
      </div>
      <div className="service-divider"></div>
    </a>

    {/* Solución 2 */}
    <a href="/SistemasPOS" className="service-row reverse">
      <div className="service-item">
        <div className="service-content">
          <h3 className="service-title">SISTEMAS POS</h3>
          <p className="service-description">
            Soluciones completas para puntos de venta inteligentes que integran hardware 
            y software para optimizar tus operaciones comerciales.
          </p>
        </div>
        <div className="service-image-container">
          <img src={sistemas_pos} alt="Sistemas POS" className="service-image" />
          <div className="image-overlay"></div>
        </div>
      </div>
      <div className="service-divider"></div>
    </a>

    {/* Solución 3 */}
    <a href="/SolarSystems" className="service-row">
      <div className="service-item">
        <div className="service-image-container">
          <img src={sistemas_energia_solar} alt="Energía Solar" className="service-image" />
          <div className="image-overlay"></div>
        </div>
        <div className="service-content">
          <h3 className="service-title">ENERGÍA SOLAR</h3>
          <p className="service-description">
            Soluciones sostenibles y eficientes para reducir costos operativos y 
            contribuir con el medio ambiente mediante tecnología solar avanzada.
          </p>
        </div>
      </div>
      <div className="service-divider"></div>
    </a>

    {/* Solución 4 */}
    <a href="/Puertas-Seguridad" className="service-row reverse">
      <div className="service-item">
        <div className="service-content">
          <h3 className="service-title">PUERTAS DE SEGURIDAD</h3>
          <p className="service-description">
            Sistemas de control de acceso de última generación con tecnología biométrica, 
            tarjetas RFID y control remoto para máxima seguridad.
          </p>
        </div>
        <div className="service-image-container">
          <img src={puertas_de_seguridad} alt="Puertas de Seguridad" className="service-image" />
          <div className="image-overlay"></div>
        </div>
      </div>
      <div className="service-divider"></div>
    </a>

    {/* Solución 5 */}
    <a href="/IntelligentParking" className="service-row">
      <div className="service-item">
        <div className="service-image-container">
          <img src={parqueaderos_inteligentes} alt="Parqueaderos Inteligentes" className="service-image" />
          <div className="image-overlay"></div>
        </div>
        <div className="service-content">
          <h3 className="service-title">PARQUEADEROS INTELIGENTES</h3>
          <p className="service-description">
            Gestión automatizada de estacionamientos con sensores, cámaras y 
            sistemas de pago integrados para una experiencia sin fricciones.
          </p>
        </div>
      </div>
      <div className="service-divider"></div>
    </a>

    {/* Solución 6 */}
    <a href="/Pantallas-Señalización" className="service-row reverse">
      <div className="service-item">
        <div className="service-content">
          <h3 className="service-title">PANTALLAS EDUCATIVAS</h3>
          <p className="service-description">
            Soluciones visuales para educación y navegación con pantallas interactivas, 
            sistemas de señalización digital y contenido dinámico.
          </p>
        </div>
        <div className="service-image-container">
          <img src={pantallas_edu_señ} alt="Pantallas Educativas" className="service-image" />
          <div className="image-overlay"></div>
        </div>
      </div>
      <div className="service-divider"></div>
    </a>

    {/* Solución 7 */}
    <a href="/licenciamiento-software" className="service-row">
      <div className="service-item">
        <div className="service-image-container">
          <img src={licenciamiento_soft} alt="Licenciamiento de Software" className="service-image" />
          <div className="image-overlay"></div>
        </div>
        <div className="service-content">
          <h3 className="service-title">LICENCIAMIENTO DE SOFTWARE</h3>
          <p className="service-description">
            Soluciones legales y optimizadas para tu negocio con licencias originales, 
            actualizaciones garantizadas y soporte técnico especializado.
          </p>
        </div>
      </div>
      <div className="service-divider"></div>
    </a>

    {/* Solución 8 */}
    <a href="/SecurityCctv" className="service-row reverse">
      <div className="service-item">
        <div className="service-content">
          <h3 className="service-title">ELECTRO SEGURIDAD</h3>
          <p className="service-description">
            Sistemas integrales de vigilancia y protección con CCTV de alta definición, 
            alarmas inteligentes y monitoreo remoto 24/7.
          </p>
        </div>
        <div className="service-image-container">
          <img src={electrosec_cctv} alt="Electro Seguridad" className="service-image" />
          <div className="image-overlay"></div>
        </div>
      </div>
      <div className="service-divider"></div>
    </a>

    {/* Solución 9 */}
    <a href="/ComputoVideoConferencia" className="service-row">
      <div className="service-item">
        <div className="service-image-container">
          <img src={computoyconferencia} alt="Cómputo y Videoconferencia" className="service-image" />
          <div className="image-overlay"></div>
        </div>
        <div className="service-content">
          <h3 className="service-title">CÓMPUTO Y VIDEOCONFERENCIA</h3>
          <p className="service-description">
            Equipos y soluciones para comunicación empresarial con tecnología de 
            videoconferencia profesional y equipos de cómputo de alto rendimiento.
          </p>
        </div>
      </div>
    </a>
  </section>
</div>

 <BrandSlider/>    
<ContactForm/>
      <Footer/>
    </div>
  );
};

export default Home;